(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedhelpmechooseblock = window.oneadvanced.refreshedhelpmechooseblock || {};
    window.oneadvanced.refreshedhelpmechooseblock.init = function () {
        //console.log("initializing refreshedhelpmechooseblock js.......");

        //Below code is to add class named threesection if the helpmechooseblock contains 3 items
        var chooseLayout = function () {
            var main_content = document.querySelectorAll('.refreshedhelpmechooseblock .main-content');
            var helpmechooseblock = document.getElementsByClassName('refreshedhelpmechooseblock');

            for (var e = 0; e < main_content.length; e++) {
                if (main_content[e].children.length == 3) {
                    helpmechooseblock[e].children[0].classList.add('threesection');
                    helpmechooseblock[e].children[0].classList.remove('twosection');
                } else {
                    helpmechooseblock[e].children[0].classList.remove('threesection');
                    helpmechooseblock[e].children[0].classList.add('twosection');
                }
            }
        }

        //Below code is used to set minHeight for the cards 
        var handleCardContentHeight = function (layout) {
            var cardHeight = [];
            var getCardContent = document.querySelectorAll('.' + layout + ' .card-section');

            for (var child = 0; child < getCardContent.length; child++) {
                getCardContent[child].style.minHeight = null;
            }

            if ((layout == 'twosection' && window.innerWidth < 640) || (layout == 'threesection' && window.innerWidth < 1025)) {
                return;
            }

            for (var child = 0; child < getCardContent.length; child++) {
                cardHeight.push(getCardContent[child].offsetHeight);
            }

            for (var child = 0; child < getCardContent.length; child++) {
                getCardContent[child].style.minHeight = `${Math.max(...cardHeight)}px`;
            }
        }

        const promise = new Promise((resolve, reject) => {
            chooseLayout();
        });

        promise.then(
            handleCardContentHeight('twosection'),
            handleCardContentHeight('threesection')
        );

        window.addEventListener("resize", function () {
            handleCardContentHeight('twosection');
            handleCardContentHeight('threesection');
        });
    };

    window.oneadvanced.refreshedhelpmechooseblock.hasLoaded = true;
})();